module.exports = __webpack_public_path__ + "static/media/ET028 new.dd168ceb.jpg";